import { Row, Rows } from "../../../interfaces";
import { withCellStyles, getCell, formats } from "../../../utils";
import { generateExcelSumFormulaForGrandOrSubTotal, headerToColumnLetter } from "../../../utils/functions";
import { BmTemplateInternals, BudgetModalTemplateCurrentState } from "../budget-helper-internal";
import { boldAndBackgroundGray, textBold } from "../../../excelStyles";

export class TotalExpensesSection {
  constructor(
    private readonly helper: BmTemplateInternals,
  ) { }

  fillTotalExpensesRows(rows: Rows, current: BudgetModalTemplateCurrentState): void {
    this.prepareTotalExpensesRow(rows, current);
    this.prepareTotalExpensesRowPcnt(rows, current);
  }

  private prepareTotalExpensesRow(newData: Rows, current: BudgetModalTemplateCurrentState): void {
    const totalExpensesRow: Row = [];
    current.totalCapitalReqIndex.push(current.rowIndex);
    totalExpensesRow.push(withCellStyles('Total expenses', textBold));
    current.expandedHeadersWithYear.forEach((header) => {
      // null header marks an empty narrow column,
      // header can not be undefined
      if (header === null) {
        totalExpensesRow.push(null);
      } else if (header !== 'Budget') {
        totalExpensesRow.push(withCellStyles(getCell({
          f: generateExcelSumFormulaForGrandOrSubTotal(header, current.expandedHeadersWithYear, current.indexArrayForTotalExpenses),
          z: formats.thousandsSeparator, t: 'n',
        }), header.includes('Y') ? boldAndBackgroundGray : textBold));
      }
    });

    this.helper.pushYearsTotalCellBold(totalExpensesRow, current.rowIndex, current.yearsIndexArray);
    this.helper.prepareCellForTotalPcnt(totalExpensesRow, current, true);
    this.helper.setCellForTotalPcntOfCommitment(totalExpensesRow, current.rowIndex, current.indexOfTotalColumn, true);
    newData.push(totalExpensesRow);
  }

  private prepareTotalExpensesRowPcnt(newData: Rows, current: BudgetModalTemplateCurrentState): void {
    const totalExpensesPcntRow: Row = [];
    totalExpensesPcntRow.push(withCellStyles('Total expenses %', textBold));
    current.expandedHeadersWithYear.forEach((header) => {
      // null header marks an empty narrow column,
      // header can not be undefined
      if (header === null) {
        totalExpensesPcntRow.push(null);
      } else if (header !== 'Budget') {
        totalExpensesPcntRow.push(withCellStyles(getCell({
          f: `IFERROR(${headerToColumnLetter(header, current.expandedHeadersWithYear)}${current.rowIndex}/${current.totalCommitment},0)`,
          z: formats.percents, t: 'n',
        }), header.includes('Y') ? boldAndBackgroundGray : textBold));
      }
    });

    this.helper.setEmptyTotalsRowWithStyle(totalExpensesPcntRow);
    newData.push(totalExpensesPcntRow);
    current.rowIndex++;
    current.rowIndex++;
  }
}
